import React from 'react';
import { MotifIcon, MotifTooltip } from '@ey-xd/motif-react';
import { actionIcInfoOutline24px } from '@ey-xd/motif-react/assets/icons';
import {
  CardTitle,
  DataCardContainerPL,
  DataContainer,
  LabelLine1,
  LabelLineHeader,
  Labels,
  Separator,
  TitleContainer,
  Value,
  ValueHeader,
  DataRowContainer,
} from '@atoms/dashboard/personalDashboard.styles';
import { DATA_CARD_ONE } from '@constants/commonConstants';

const DataCardOne = ({ data }) => {
  return (
    data && (
      <DataCardContainerPL>
        <TitleContainer>
          <CardTitle>{DATA_CARD_ONE.FORECAST_ACCURACY}</CardTitle>
          <MotifTooltip
            id="bottom"
            trigger={
              <MotifIcon
                src={actionIcInfoOutline24px}
                style={{ width: '16px', height: '16px', marginTop: '3px' }}
              />
            }
            allowHover={true}
            allowClick={true}
            placement="bottom"
          >
            If your forecasted value matches the <br /> actual Won value for each quarter/month
            <br /> of this fiscal year, your accuracy will be <br /> 100%. However, if there is any
            variance, <br /> whether it&apos;s higher or lower, your <br /> accuracy will decrease.
          </MotifTooltip>
        </TitleContainer>
        <DataContainer>
          <ValueHeader>{data.targetAccuracy}</ValueHeader>
          <Labels>
            <LabelLineHeader>Target Accuracy Range</LabelLineHeader>
          </Labels>
        </DataContainer>
        <Separator />
        <DataRowContainer>
          <DataContainer>
            <Value>{data.quarter.submitted}</Value>
            <Labels>
              <LabelLine1>Quarters Submitted</LabelLine1>
            </Labels>
          </DataContainer>
          <DataContainer>
            <Value>{data.quarter.onTrack}</Value>
            <Labels>
              <LabelLine1>Quarters On Track</LabelLine1>
            </Labels>
          </DataContainer>
        </DataRowContainer>
        <Separator />
        <DataRowContainer>
          <DataContainer>
            <Value>{data.month.submitted}</Value>
            <Labels>
              <LabelLine1>Months Submitted</LabelLine1>
            </Labels>
          </DataContainer>
          <DataContainer>
            <Value>{data.month.onTrack}</Value>
            <Labels>
              <LabelLine1>Months On Track</LabelLine1>
            </Labels>
          </DataContainer>
        </DataRowContainer>
      </DataCardContainerPL>
    )
  );
};

export default DataCardOne;
